import { Opaque } from 'type-fest';

export type UUID = Opaque<string, 'UUID'>;

export function isUUID(str: string): str is UUID {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
}
